import React from 'react';
import Badge, { BadgeTypeEnum } from '../../atoms/badge';
import { AddressItem } from '../../types/AddressPayload';

export const ACCEPTING_NEW_PATIENTS_OLD_MESSAGE = 'Accepting new patients';
export const NOT_ACCEPTING_NEW_PATIENTS_OLD_MESSAGE = 'Not accepting new patients';
const ACCEPTING_NEW_PATIENTS_MESSAGE = 'Accepting All Patients';
const NOT_ACCEPTING_NEW_PATIENTS_MESSAGE = 'Not Accepting New Patients';

export const AcceptingNewPatientsBadge = ({
  item,
  shouldDisplayNewPatientsIcon,
}: {
  item: AddressItem;
  shouldDisplayNewPatientsIcon: boolean;
}) => {
  return (
    <Badge
      badgeType={
        item.acceptNewPatients
          ? BadgeTypeEnum.acceptingNewPatients
          : BadgeTypeEnum.notAcceptingNewPatients
      }
      title={
        item.acceptNewPatients
          ? shouldDisplayNewPatientsIcon
            ? ACCEPTING_NEW_PATIENTS_MESSAGE
            : ACCEPTING_NEW_PATIENTS_OLD_MESSAGE
          : shouldDisplayNewPatientsIcon
          ? NOT_ACCEPTING_NEW_PATIENTS_MESSAGE
          : NOT_ACCEPTING_NEW_PATIENTS_OLD_MESSAGE
      }
      tooltip=""
      hideTooltip={true}
    />
  );
};
